import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API_URL from './api/config';

function DeleteMyAccountVerify() {
    
    const navigate = useNavigate(); 
    
    const [values, setValues] = useState({ verify_code: '' });
    const [loading, setLoading] = useState(false);
    axios.defaults.withCredentials = true;

    const handleVerifyCode = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const res = await axios.put(`${API_URL}/delete-my-account-code-api`, {
                verify_code: values.verify_code
            });

            if (res.data.Status === "Success") {
                toast.success("Account Successfully deleted!", {
                    position: "top-right",
                    autoClose: 3000
                });

                navigate(res.data.redirect);
            } else {
                toast.error(res.data.Message || "Verification failed", {
                    position: "top-right",
                    autoClose: 3000
                });
            }
        } catch (err) {
            toast.error(
                err.response?.data?.error || "Something went wrong",
                {
                    position: "top-right",
                    autoClose: 3000
                }
            );
        } finally {
            setLoading(false);
        }
    };
      
    return (
        <div className="bg_med_green text-white min-vh-100 d-flex align-items-center justify-content-center"  >
            <ToastContainer />
            <div className="container" style={{ maxWidth: '600px', padding: '1rem' }}>
                <div className="row justify-content-center">
                    <div className="col-md-6 col-lg-6" style={{ width: '100%' }}>
                        <div className="bg-med-green text-white p-0 rounded" style={{
                            background: '#ffffff',
                            borderRadius: '28px',
                            overflow: 'hidden',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}>
                            <div className="card-body text-center" style={{ padding: 0 }}>
                                
                                {/* Header with brand colors */}
                                <div style={{
                                    background: 'linear-gradient(135deg, #0d6e28 0%, #0a5520 100%)',
                                    padding: '2rem 2rem 1.5rem 2rem',
                                    borderBottom: '1px solid rgba(255,255,255,0.1)'
                                }}>
                                    <div className="py-3" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '12px' }}>
                                        <img src="img/logo_1.png" alt="Oret Africa" height="48" style={{ filter: 'brightness(0) invert(1)' }} />
                                    </div>
                                    <h3 style={{
                                        fontFamily: "'Playfair Display', serif",
                                        fontSize: '1.75rem',
                                        fontWeight: '600',
                                        marginTop: '0.5rem',
                                        marginBottom: '0',
                                        color: '#ffffff'
                                    }}>Verify Deletion</h3>
                                    <p style={{
                                        fontSize: '0.85rem',
                                        opacity: 0.9,
                                        marginTop: '0.5rem',
                                        marginBottom: '0',
                                        color: '#e0f0e5'
                                    }}>Enter the 6-digit code sent to your email</p>
                                </div>

                                <form onSubmit={handleVerifyCode} style={{ padding: '2rem' }}>
                                    <div className="row g-4">
                                        
                                        {/* Warning message */}
                                        <div className='col-12'>
                                            <div style={{
                                                background: '#fff3e0',
                                                borderLeft: '4px solid #ff6600',
                                                borderRadius: '12px',
                                                padding: '1rem',
                                                marginBottom: '0.5rem',
                                                textAlign: 'left'
                                            }}>
                                                <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start' }}>
                                                    <span style={{ fontSize: '1.2rem' }}>⚠️</span>
                                                    <div>
                                                        <p style={{ 
                                                            margin: 0, 
                                                            color: '#5a3a1a', 
                                                            fontSize: '0.85rem', 
                                                            fontWeight: '500',
                                                            lineHeight: '1.5'
                                                        }}>
                                                            <strong>Permanent action:</strong> This will permanently delete all your family tree data, media, and connections. This action cannot be undone.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Verification code input */}
                                        <div className="col-12">
                                            <label style={{
                                                display: 'block',
                                                textAlign: 'left',
                                                fontWeight: '600',
                                                color: '#1a3a24',
                                                fontSize: '0.85rem',
                                                marginBottom: '0.5rem',
                                                letterSpacing: '-0.2px'
                                            }}>
                                                <i className="fas fa-key" style={{ marginRight: '8px', fontSize: '0.8rem' }}></i>
                                                Verification Code
                                            </label>
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Enter 6-digit code" 
                                                maxLength="6"
                                                onChange={e => setValues({ ...values, verify_code: e.target.value })} 
                                                required 
                                                style={{
                                                    border: '2px solid #e1ebe3',
                                                    borderRadius: '14px',
                                                    padding: '0.85rem 1rem',
                                                    fontSize: '0.95rem',
                                                    transition: 'all 0.2s ease',
                                                    fontFamily: "'DM Sans', sans-serif",
                                                    textAlign: 'center',
                                                    letterSpacing: '4px',
                                                    fontWeight: '600'
                                                }}
                                                onFocus={(e) => e.target.style.borderColor = '#0d6e28'}
                                                onBlur={(e) => e.target.style.borderColor = '#e1ebe3'}
                                            />
                                            
                                        </div>

                                        {/* Verify button */}
                                        <div className="col-12">
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100"
                                                disabled={loading}
                                                style={{
                                                    background: loading ? '#c0cfc5' : '#ff6600',
                                                    border: 'none',
                                                    borderRadius: '40px',
                                                    padding: '0.9rem 1rem',
                                                    fontWeight: '600',
                                                    fontSize: '0.95rem',
                                                    letterSpacing: '0.3px',
                                                    transition: 'all 0.2s ease',
                                                    cursor: loading ? 'not-allowed' : 'pointer',
                                                    color: '#ffffff'
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!loading) e.target.style.background = '#e55a00';
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!loading) e.target.style.background = '#ff6600';
                                                }}
                                            >
                                                {loading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style={{ width: '1rem', height: '1rem' }}></span>
                                                        Verifying...
                                                    </>
                                                ) : (
                                                    <>
                                                        <i className="fas fa-trash-alt me-2"></i>
                                                        Verify code to delete account
                                                    </>
                                                )}
                                            </button>
                                        </div>

                                        {/* Help text */}
                                        <div className="col-12">
                                            <p style={{
                                                fontSize: '0.75rem',
                                                color: '#8aa899',
                                                marginTop: '0.5rem',
                                                marginBottom: 0,
                                                textAlign: 'center'
                                            }}>
                                                <i className="fas fa-envelope" style={{ marginRight: '6px' }}></i>
                                                Didn't receive the code? Check your spam folder or{' '}
                                                <a 
                                                    href="#" 
                                                    style={{ color: '#0d6e28', textDecoration: 'none', fontWeight: '500' }}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        toast.info("Please request a new code from the previous page", {
                                                            position: "top-right",
                                                            autoClose: 3000
                                                        });
                                                    }}
                                                >
                                                    request a new one
                                                </a>
                                            </p>
                                        </div>

                                    </div>
                                </form>

                                {/* Footer with back link */}
                                <div style={{
                                    borderTop: '1px solid #e5ede8',
                                    padding: '1rem 2rem',
                                    background: '#fafdfb'
                                }}>
                                    <p style={{
                                        fontSize: '0.75rem',
                                        color: '#8aa899',
                                        margin: 0,
                                        textAlign: 'center'
                                    }}>
                                        <i className="fas fa-arrow-left me-1"></i>
                                        Changed your mind?{' '}
                                        <a 
                                            href="#" 
                                            style={{ color: '#0d6e28', textDecoration: 'none', fontWeight: '500' }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                navigate(-1);
                                            }}
                                        >
                                            Go back
                                        </a>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeleteMyAccountVerify;